import { lazy } from 'react';
import MultiMatchManageQuestions from '../container/EliteGames/MultiMatch/MultiMatchManageQuestions.jsx';
import FunLearnManageQuestions from '../container/EliteGames/FunAndLearn/FunLearnManageQuestions.jsx';
import GuessWordManageQuestions from '../container/EliteGames/GuessTheWord/GuessWordManageQuestions.jsx';
import AudioManageQuestions from '../container/EliteGames/AudioQuestions/AudioManageQuestions.jsx';
import MathsQuizManageQuestions from '../container/EliteGames/MathsQuiz/MathsQuizManageQuestions.jsx';
import ManageQuestions from '../container/EliteGames/Contest/ManageQuestions.jsx';
import DailyQuiz from '../container/EliteGames/DailyQuiz/DailyQuiz.jsx';
import ExamModule from '../container/EliteGames/ExamModule/ExamModule.jsx';
import ExamModuleImportQuestions from '../container/EliteGames/ExamModule/ExamModuleImportQuestions.jsx';
import ExamModuleManageQuestions from '../container/EliteGames/ExamModule/ExamModuleManageQuestions.jsx';
import MathQuizImportQuestion from '../container/EliteGames/MathsQuiz/MathQuizImportQuestion.jsx';
import GuessWordImportQues from '../container/EliteGames/GuessTheWord/GuessWordImportQues.jsx';
import FunLearnImportQues from '../container/EliteGames/FunAndLearn/FunLearnImportQues.jsx';
import QuizSettingsPage from '../container/EliteGames/Settings/EliteGameSetting.jsx';
import AllLeaderBoard from '../container/EliteGames/Leaderboard/AllLeaderBoard.jsx';
import MonthlyLeaderBoard from '../container/EliteGames/Leaderboard/MonthlyLeaderBoard.jsx';
import DailyLeaderBoard from '../container/EliteGames/Leaderboard/DailyLeaderBoard.jsx';
import Language from '../container/EliteGames/Language/Language.jsx';
import DailyQuizManageQuestions from '../container/EliteGames/DailyQuiz/DailyQuizManageQuestions.jsx';
import DailyQuizImportQuestion from '../container/EliteGames/DailyQuiz/DailyQuizImportQuestion.jsx';

// Lazy imports for Elite Game components
const quizZoneMainCategory = lazy(() =>
  import('../container/EliteGames/QuizZone/quizZoneMainCategory.jsx')
);
const QuizZoneSubCategory = lazy(() =>
  import('../container/EliteGames/QuizZone/quizZoneSubCategory.jsx')
);
const ManageContest = lazy(() => import('../container/EliteGames/Contest/ManageContest.jsx'));
const MultiMatchMainCategory = lazy(() =>
  import('../container/EliteGames/MultiMatch/MultiMatchMainCategory.jsx')
);
const FunLearnMainCategory = lazy(() =>
  import('../container/EliteGames/FunAndLearn/FunLearnMainCategory.jsx')
);
const GuessWordMainCategory = lazy(() =>
  import('../container/EliteGames/GuessTheWord/GuessWordMainCategory.jsx')
);
const AudioQuesMainCategory = lazy(() =>
  import('../container/EliteGames/AudioQuestions/AudioQuesMainCategory.jsx')
);
const MathsQuizMainCategory = lazy(() =>
  import('../container/EliteGames/MathsQuiz/MathsQuizMainCategory.jsx')
);
const MultiMatchSubCategory = lazy(() =>
  import('../container/EliteGames/MultiMatch/MultiMatchSubCategory.jsx')
);
const FunLearnSubCategory = lazy(() =>
  import('../container/EliteGames/FunAndLearn/FunLearnSubCategory.jsx')
);
const GuessWordSubCategory = lazy(() =>
  import('../container/EliteGames/GuessTheWord/GuessWordSubCategory.jsx')
);
const AudioQuesSubCategory = lazy(() =>
  import('../container/EliteGames/AudioQuestions/AudioQuesSubCategory.jsx')
);
const MathsQuizSubCategory = lazy(() =>
  import('../container/EliteGames/MathsQuiz/MathsQuizSubCategory.jsx')
);
const QuizZoneImportQuestion = lazy(() =>
  import('../container/EliteGames/QuizZone/QuizZoneImportQuestion.jsx')
);
const MultiMatchImportQues = lazy(() =>
  import('../container/EliteGames/MultiMatch/MultiMatchImportQues.jsx')
);
const QuizZoneCategoryOrder = lazy(() =>
  import('../container/EliteGames/QuizZone/QuizZoneCategoryOrder.jsx')
);
const QuizZoneViewQuestions = lazy(() =>
  import('../container/EliteGames/QuizZone/QuizZoneViewQuestions.jsx')
);
const FunLearnCategoryOrder = lazy(() =>
  import('../container/EliteGames/FunAndLearn/FunLearnCategoryOrder.jsx')
);
const FunLearnCreateNManage = lazy(() =>
  import('../container/EliteGames/FunAndLearn/FunLearnCreateNManage.jsx')
);
const MathsQuizCategoryOrder = lazy(() =>
  import('../container/EliteGames/MathsQuiz/MathsQuizCategoryOrder.jsx')
);
const QuizZoneManageQuestions = lazy(() =>
  import('../container/EliteGames/QuizZone/QuizZoneManageQuestions.jsx')
);
const MultiMatchCategoryOrder = lazy(() =>
  import('../container/EliteGames/MultiMatch/MultiMatchCategoryOrder.jsx')
);
const GuessWordCategoryOrder = lazy(() =>
  import('../container/EliteGames/GuessTheWord/GuessWordCategoryOrder.jsx')
);
const AudioQuestionsCategoryOrder = lazy(() =>
  import('../container/EliteGames/AudioQuestions/AudioQuestionsCategoryOrder.jsx')
);

// Elite Games child routes
const eliteGameRoutes = [
  // QuizZone Routes
  {
    path: '',
    redirectTo: 'quizZone/main-category'
  },
  {
    path: 'quizZone/main-category',
    name: 'quizZoneMainCategory',
    component: quizZoneMainCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'quizZone/sub-category',
    name: 'quizZonesubCategory',
    component: QuizZoneSubCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'quizZone/category-order',
    name: 'quizZonesubCategoryList',
    component: QuizZoneCategoryOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'quizZone/manage-questions',
    name: 'quizZoneManageQuestions',
    component: QuizZoneManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'quizZone/import-questions',
    name: 'QuizZoneImportQuestions',
    component: QuizZoneImportQuestion,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'quizZone/view-questions',
    name: 'QuizZoneViewQuestions',
    component: QuizZoneViewQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  //Daily Quiz Routes
  {
    path: 'daily-quiz/manage-questions',
    name: 'DailyQuizManageQuestions',
    component: DailyQuizManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'daily-quiz/import-questions',
    name: 'DailyQuizImportQuestions',
    component: DailyQuizImportQuestion,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Contest Routes
  {
    path: 'contest/manage-contest',
    name: 'ManageContest',
    component: ManageContest,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'contest/manage-questions',
    name: 'ContestManageQuestions',
    component: ManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  {
    path: 'exam-module/mainCategory',

    name: 'ExamModule',
    component: ExamModule,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'exam-module/exam-import-questions',

    name: 'ExamModuleImportQuestions',
    component: ExamModuleImportQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'exam-module/exam-manage-questions',
    name: 'ExamModuleManageQuestions',
    component: ExamModuleManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  // MultiMatch Routes
  {
    path: 'multi-match/mainCategory',

    name: 'MultiMatchMainCategory',
    component: MultiMatchMainCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'multi-match/subcategory',

    name: 'MultiMatchSubCategory',
    component: MultiMatchSubCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'multi-match/category-order',

    name: 'MultiMatchCategoryOrder',
    component: MultiMatchCategoryOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'multi-match/manage-questions',

    name: 'MultiMatchManageQuestions',
    component: MultiMatchManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'multi-match/import-questions',

    name: 'MultiMatchImportQuestions',
    component: MultiMatchImportQues,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // FunAndLearn Routes
  {
    path: 'fun-n-learn/maincategory',

    name: 'FunAndLearnCategory',
    component: FunLearnMainCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'fun-n-learn/subcategory',

    name: 'FunAndLearnSubCategory',
    component: FunLearnSubCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'fun-n-learn/category-order',

    name: 'FunAndLearnCategoryOrder',
    component: FunLearnCategoryOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'fun-n-learn/manage-questions',

    name: 'FunAndLearnManageQuestions',
    component: FunLearnManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'fun-n-learn/create-n-manage',

    name: 'FunAndLearnCreateAndManage',
    component: FunLearnCreateNManage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'fun-n-learn/import-questions',

    name: 'FunAndLearnImportQuestions',
    component: FunLearnImportQues,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  // GuessTheWord Routes
  {
    path: 'guess-the-word-category',

    name: 'GuessTheWordCategory',
    component: GuessWordMainCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'guess-the-word/subcategory',

    name: 'GuessTheWordSubCategory',
    component: GuessWordSubCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'guess-the-word/category-order',

    name: 'GuessTheWordCategoryOrder',
    component: GuessWordCategoryOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'guess-the-word/manage-questions',

    name: 'GuessTheWordManageQuestions',
    component: GuessWordManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'guess-the-word/import-questions',

    name: 'GuessTheWordImportQuestions',
    component: GuessWordImportQues,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // AudioQuestions Routes
  {
    path: 'audio-questions-category',

    name: 'AudioQuestionsCategory',
    component: AudioQuesMainCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'audio-questions/subcategory',

    name: 'AudioQuestionsSubCategory',
    component: AudioQuesSubCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'audio-questions/category-order',

    name: 'AudioQuestionsCategoryOrder',
    component: AudioQuestionsCategoryOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'audio-questions/manage-questions',

    name: 'AudioQuestionsManageQuestions',
    component: AudioManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // MathsQuiz Routes
  {
    path: 'maths-quiz-category',

    name: 'MathsQuizCategory',
    component: MathsQuizMainCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'maths-quiz-subcategory',

    name: 'MathsQuizSubCategory',
    component: MathsQuizSubCategory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'maths-quiz/category-order',

    name: 'MathsQuizCategoryOrder',
    component: MathsQuizCategoryOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'maths-quiz/manage-questions',

    name: 'MathsQuizManageQuestions',
    component: MathsQuizManageQuestions,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'maths-quiz/import-questions',

    name: 'MathsQuizImportQuestions',
    component: MathQuizImportQuestion,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'settings',
    name: 'QuizSettingsPage',
    component: QuizSettingsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'leaderboard/all',
    name: 'LeaderboardAll',
    component: AllLeaderBoard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'leaderboard/monthly',
    name: 'LeaderboardMonthly',
    component: MonthlyLeaderBoard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'leaderboard/daily',
    name: 'LeaderboardDaily',
    component: DailyLeaderBoard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: 'language',
    name: 'Language',
    component: Language,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  }
];

export default eliteGameRoutes;
